const handleUpdateEmployerCSFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.message = action.payload.message;
};
const handleSearchStaffFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.staffList = action.payload.data;
};
const handleSearchCsStaffFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.employerCsStaffList = action.payload.data;
}
const handleChangeEmployerCsFulfilled = (state) => {
    state.status = 'succeeded';   
}
export {
    handleUpdateEmployerCSFulfilled,
    handleSearchStaffFulfilled,
    handleSearchCsStaffFulfilled,
    handleChangeEmployerCsFulfilled
};
